import graphql__50ae3c707ed4ba2e3e18 from "./__generated__/PageSection_pageSection.graphql.js";import { graphql, useFragment } from "react-relay";

import PageSectionText from "./PageSectionText";
import PageSectionBanner from "./PageSectionBanner";
import PageSectionParticipativeModulesList from "./PageSectionParticipativeModulesList";
import PageSectionEventsList from "./PageSectionEventsList";
import PageSectionActorsList from "./PageSectionActorsList";
import PageSectionPagesList from "./PageSectionPagesList";
import PageSectionFilesList from "./PageSectionFilesList";
import PageSectionFeaturedContent from "./PageSectionFeaturedContent";
import PageSectionEmbed from "./PageSectionEmbed";
import PageSectionParticipativeModuleResults from "./PageSectionParticipativeModuleResults";
import PageSectionMap from "./PageSectionMap";
import PageSectionSearchBox from "./PageSectionSearchBox";
import PageSectionAnalyticsDataList from "./PageSectionAnalyticsDataList";
import PageSectionMapElementFeatureAttribute from "./PageSectionMapElementFeatureAttribute";
import PageSectionCookiesConsentsConfiguration from "./PageSectionCookiesConsentsConfiguration";
import PageSectionSitemap from "./PageSectionSitemap";
import PageSectionCalendar from "./PageSectionCalendar";
import PageSectionInformationSearch from "./PageSectionInformationSearch";
import PageSectionSidebarCalendar from "./PageSectionSidebarCalendar";
import PageSectionSidebarEventsList from "./PageSectionSidebarEventsList";
import PageSectionSidebarFilesList from "./PageSectionSidebarFilesList";
import PageSectionSidebarBanner from "./PageSectionSidebarBanner";
import PageSectionSidebarLinkBlock from "./PageSectionSidebarLinkBlock";
import PageSectionSidebarText from "./PageSectionSidebarText";
import PageSectionSidebarUsersGroupRequestLinkBlock from "./PageSectionSidebarUsersGroupRequestLinkBlock";

const PageSectionTypes = {
  PageSectionText,
  PageSectionBanner,
  PageSectionParticipativeModulesList,
  PageSectionEventsList,
  PageSectionCalendar,
  PageSectionActorsList,
  PageSectionPagesList,
  PageSectionFilesList,
  PageSectionFeaturedContent,
  PageSectionEmbed,
  PageSectionParticipativeModuleResults,
  PageSectionMap,
  PageSectionSearchBox,
  PageSectionAnalyticsDataList,
  PageSectionMapElementFeatureAttribute,
  PageSectionCookiesConsentsConfiguration,
  PageSectionSitemap,
  PageSectionInformationSearch,
  PageSectionSidebarCalendar,
  PageSectionSidebarEventsList,
  PageSectionSidebarFilesList,
  PageSectionSidebarBanner,
  PageSectionSidebarLinkBlock,
  PageSectionSidebarText,
  PageSectionSidebarUsersGroupRequestLinkBlock
};

const PageSection = props => {
  const pageSection = useFragment(PageSection_pageSection, props.pageSection);
  const PageSectionType = PageSectionTypes[pageSection.__typename];
  return <PageSectionType pageSection={pageSection} />;
};

const PageSection_pageSection = graphql__50ae3c707ed4ba2e3e18;

export default PageSection;
